// client/src/components/AuthenticatedAppProviders.js
import React from 'react';
import { useAuth } from '../state/AuthContext';
import { StudentProgressProvider } from '../state/StudentProgressContext';

function AuthenticatedAppProviders({ children }) {
  const { isLoggedIn, loading } = useAuth();

  // While checking auth, show a loading indicator or nothing
  if (loading) {
    return <div>Loading application...</div>;
  }

  // If logged in, provide the student progress context
  if (isLoggedIn) {
    return (
      <StudentProgressProvider>
        {children}
      </StudentProgressProvider>
    );
  }

  // If not logged in, just render the children
  return <>{children}</>;
}

export default AuthenticatedAppProviders;